<span class="tooltip mr-1" [attr.data-tip]="text">
  <fa-icon [icon]="faCircleInfo"></fa-icon>
</span>
<span class="truncate block">{{ text }}</span>
